import { FC } from 'react';
import { ScrollArea, ScrollBar } from '@/components/ui/scroll-area';
import { BatteryContainer3D } from './BatteryContainer3D';
import type { Container, Battery } from '@/hooks/useBatteryContainers';

interface ContainerScrollBarProps {
  containers: Container[];
  batteries: Battery[];
  allocations?: Map<string, string>;
  onBatteryDrop?: (batteryId: string, leadId: string) => void;
  onAddBatteries?: (container: Container) => void;
  onEditContainer?: (container: Container) => void;
  onDeleteContainer?: (container: Container) => void;
  onEditBattery?: (battery: Battery) => void;
  onDeleteBattery?: (battery: Battery) => void;
  onAllocateBattery?: (battery: Battery) => void;
  onBookToStock?: (container: Container) => void;
}

export const ContainerScrollBar: FC<ContainerScrollBarProps> = ({
  containers,
  batteries,
  allocations,
  onBatteryDrop,
  onAddBatteries,
  onEditContainer,
  onDeleteContainer,
  onEditBattery,
  onDeleteBattery,
  onAllocateBattery,
  onBookToStock,
}) => {
  return (
    <ScrollArea className="w-full whitespace-nowrap">
      <div className="flex gap-4 p-1">
        {containers.map((container) => (
          <BatteryContainer3D
            key={container.id}
            container={container}
            batteries={batteries}
            allocations={allocations}
            onBatteryDrop={onBatteryDrop}
            onAddBatteries={onAddBatteries ? () => onAddBatteries(container) : undefined}
            onEditContainer={onEditContainer ? () => onEditContainer(container) : undefined}
            onDeleteContainer={onDeleteContainer ? () => onDeleteContainer(container) : undefined}
            onEditBattery={onEditBattery}
            onDeleteBattery={onDeleteBattery}
            onAllocateBattery={onAllocateBattery}
            onBookToStock={onBookToStock ? () => onBookToStock(container) : undefined}
          />
        ))}
      </div>
      <ScrollBar orientation="horizontal" />
    </ScrollArea>
  );
};
